export enum FilterType {
  all = 'all',
  location = 'location',
  installation = 'installation',
  campaign = 'campaign',
  playlist = 'playlist',
  zone = 'zone',
  gate = 'gate',
  crossingLine = 'crossing_line'
}